export const checkoutUrl = 'https://obesitybp-en.impultienda.ar/checkout/';

export const images = {
  hero: 'https://cdn.magicpatterns.com/uploads/4viNxJvbRZMkbyhE4E67vr/OBESITYBP-EN.png',
  author: 'https://cdn.magicpatterns.com/uploads/mtXh8acCp9BGXL5vEbqq57/Dr._Henry_Wells_-_DIABETES.png',
};
